/**
 * Reply drafts' client state: which draft each composer's text came from,
 * and the key of the open drafts a send refreshes. It loads Zustand and
 * storage and nothing else, so the chat's send hook can name the draft without
 * pulling the sheet, the adapter and the HTTP client in behind it.
 */
export { OPEN_REPLY_DRAFTS_QUERY_KEY } from '../model/queryKeys';
export {
  clearHandOff,
  readHandOffLink,
  recordHandOff,
  useHandOffLink,
  type HandOffLink,
} from './handOffStore';
